import { Button, Col, Row, Typography } from 'antd'
import styled from 'styled-components'

import React from 'react'
import { Link } from 'react-router-dom'

import { HubListItem } from '@a4b/api/src/modules/Monetisation/offerings/types'

const { Title } = Typography
interface Props {
  data: HubListItem
  link: string
}
const Container = styled.div`
  padding: 10px;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  background-color: #fff;
  border: 1px solid #bfbfbf;
  .ant-card-body {
    flex-grow: 1;
  }
  flex-direction: row;
  &:hover {
    cursor: pointer;
  }
`
const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
`
const ContentWrapper = styled(Title)`
  margin-bottom: 0 !important;
  margin-top: 0;
`
const SubTitleWrapper = styled.span`
  color: #434343;
`
const LabelRightAlign = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  height: 100%;
`
const Anchor = styled(Link)`
  margin-bottom: 20px;
  display: block;
`
const HubListItemInfo: React.FC<Props> = ({
  data: {
    name,
    total_temples,
    manager_name,
    total_active_batches,
  },
  link,
}) => {
  return (
    <Anchor to={link} key={link}>
      <Container>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          style={{ width: '100%' }}
        >
          <Col className='gutter-row' span={10}>
            <InfoWrapper>
              <ContentWrapper level={5}>{name}</ContentWrapper>
              <SubTitleWrapper>{`${total_temples} Temples`}</SubTitleWrapper>
            </InfoWrapper>
          </Col>
          <Col className='gutter-row' span={6}>
            <InfoWrapper>
              <ContentWrapper level={5}>
                {total_active_batches}
              </ContentWrapper>
              <SubTitleWrapper>Active Batches</SubTitleWrapper>
            </InfoWrapper>
          </Col>
          <Col className='gutter-row' span={6}>
            <LabelRightAlign>
              <Button type='text'>{`Managed by ${manager_name}`} &rarr;</Button>
            </LabelRightAlign>
          </Col>
        </Row>
      </Container>
    </Anchor>
  )
}
export default HubListItemInfo
